import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../api';

const SiteSettingsContext = createContext({});

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    settingsAPI.getPublic()
      .then(res => { setSettings(res.data.settings || {}); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  // Dynamic favicon
  useEffect(() => {
    if (settings.site_favicon) {
      const link = document.getElementById('dynamic-favicon') || document.querySelector("link[rel*='icon']");
      if (link) {
        link.href = settings.site_favicon.startsWith('http') ? settings.site_favicon : 'https://topinfo.rw' + settings.site_favicon;
      }
    }
  }, [settings.site_favicon]);

  return (
    <SiteSettingsContext.Provider value={{ settings, loaded }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
